
import { ViewItem } from '../../Components/Views/ViewItem';
import './unsubscribe.css';

class UnsubscribeView extends ViewItem {

    componentDidMount() {
        const token = new URLSearchParams(window.location.search).get('token')
        if (!token) return
        fetch('/api/unsubscribe/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token }),
        }).catch(() => {})
    }

    render() {
        return (
            <div className="page unsub-page">
                <div className="unsub-card">
                    {/* <a href="/" className="unsub-logo">Wyens</a> */}
                    <div className="unsub-icon">✓</div>
                    <h1 className="unsub-title">You've been unsubscribed</h1>
                    <p className="unsub-desc">
                        You won't receive any further marketing emails from Wyens.
                    </p>
                    <p className="unsub-note">
                        Changed your mind? <a href="mailto:support@wyens.co" className="unsub-link">Contact us</a>
                    </p>
                    <a href="/" className="unsub-btn">Back to Wyens</a>
                </div>
            </div>
        )
    }
}

export { UnsubscribeView }